import { formatDate } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PublisherStatus } from '../../_models/models';

export interface PublisherStatusPillInput {
  status: PublisherStatus | string;
  accountingId: number | string | null;
  statusModificationDate?: string;
}

interface PublisherStatusPillView {
  label: string;
  cssClass: string;
  tooltip: string | null;
}

@Component({
  selector: 'app-publisher-status-pill',
  templateUrl: './publisher-status-pill.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublisherStatusPillComponent {
  @Input() publisher: PublisherStatusPillInput | null = null;

  get pill(): PublisherStatusPillView {
    const row = this.publisher;
    if (row?.status === PublisherStatus.ACTIVE) {
      return { label: 'Active', cssClass: 'active-status', tooltip: null };
    }
    if (row?.status === PublisherStatus.PENDING_ACTIVATION) {
      const tooltip = row.statusModificationDate
        ? `Request sent on ${formatDate(row.statusModificationDate, 'MM/dd/yyyy', 'en-US')}`
        : 'Request sent';
      return { label: 'Pending Activation', cssClass: 'inactive-status', tooltip };
    }
    if (row?.accountingId === null) {
      return {
        label: 'Inactive',
        cssClass: 'inactive-status-ligher',
        tooltip: 'NetSuite ID is mandatory for publisher activation',
      };
    }
    return { label: 'Inactive', cssClass: 'inactive-status', tooltip: null };
  }
}
